import { Params } from '@angular/router';

import { ProductMeta } from '@proto/store/api/common/common';
import { RoutePaths } from '@helper/route-paths';

export class Urls {
  static encodeUrlParam(param: string): string {
    if (!param) {
      return '';
    }
    // 使用 btoa 進行 Base64 編碼，再將 Base64 字符轉為 URL-safe Base64
    return btoa(param).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  static decodeUrlParam(urlSafeBase64: string): string {
    if (!urlSafeBase64) {
      return '';
    }
    if (urlSafeBase64.includes('%')) {
      urlSafeBase64 = decodeURIComponent(urlSafeBase64);
    }
    // 還原 URL-safe Base64 字符為標準 Base64
    return atob(urlSafeBase64.replace(/-/g, '+').replace(/_/g, '/'));
  }

  static pathToParams(path: string, keepMark = true): string {
    const queryParams = path.split('?')[1];
    if (queryParams) {
      return `${keepMark ? '?' : ''}${queryParams}`;
    }
    return '';
  }

  static fromMeta(meta: ProductMeta | undefined, colorId = ''): string {
    return !meta ? '' : `/${[RoutePaths.PRODUCT, `${meta.productId}${colorId ? `${colorId}10` : ''}`].join('/')}`;
  }

  static fromSkuId(skuId: string): string {
    return `/${[RoutePaths.PRODUCT, `${skuId}`].join('/')}`;
  }

  static metaToParam(meta: ProductMeta | undefined): Params | undefined {
    if (!meta) {
      return undefined;
    }
    return { meta: JSON.stringify(meta) };
  }

  static getImageSizeFromUrl(url: string): [number, number] | undefined {
    const hash = decodeURIComponent(url).split('/').pop();
    if (!hash) {
      return undefined;
    }
    const width = Number(hash.substring(0, 4));
    const height = Number(hash.substring(4, 8));
    if (!width || !height) {
      return undefined;
    }
    return [width, height];
  }
}
